import { render, staticRenderFns } from "./PointModal.vue?vue&type=template&id=f29cb8f0"
import script from "./PointModal.vue?vue&type=script&lang=js"
export * from "./PointModal.vue?vue&type=script&lang=js"
import style0 from "./PointModal.vue?vue&type=style&index=0&id=f29cb8f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports